module.exports = __webpack_public_path__ + "assets/img/c778331ac496e8e4ba945e5f110b3b05.png";